// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddFieldsController from "./add_fields_controller"
application.register("add-fields", AddFieldsController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatetimepickerController from "./datetimepicker_controller"
application.register("datetimepicker", DatetimepickerController)

import DpickerController from "./dpicker_controller"
application.register("dpicker", DpickerController)

import EventRegistrationController from "./event_registration_controller"
application.register("event-registration", EventRegistrationController)

import InfoMailModalController from "./info_mail_modal_controller"
application.register("info-mail-modal", InfoMailModalController)

import MatrixController from "./matrix_controller"
application.register("matrix", MatrixController)

import MobileNavbarController from "./mobile_navbar_controller"
application.register("mobile-navbar", MobileNavbarController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiuploadController from "./multiupload_controller"
application.register("multiupload", MultiuploadController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import PaidOnController from "./paid_on_controller"
application.register("paid-on", PaidOnController)

import PrefillController from "./prefill_controller"
application.register("prefill", PrefillController)

import RegistrationWizardController from "./registration_wizard_controller"
application.register("registration-wizard", RegistrationWizardController)

import ReloadPopoverController from "./reload_popover_controller"
application.register("reload-popover", ReloadPopoverController)

import RemoveFieldsController from "./remove_fields_controller"
application.register("remove-fields", RemoveFieldsController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import ScrollingAnimationController from "./scrolling_animation_controller"
application.register("scrolling-animation", ScrollingAnimationController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SelectpickerController from "./selectpicker_controller"
application.register("selectpicker", SelectpickerController)

import SlideshowController from "./slideshow_controller"
application.register("slideshow", SlideshowController)

import VoucherController from "./voucher_controller"
application.register("voucher", VoucherController)
